
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-projects",
      function () {
        return require("private-next-pages/national-projects.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-projects"])
      });
    }
  